import React from "react";
import Footer from '../components/Footer';
import AboutSection from '../components/AboutSection';
import AboutServicesSection from '../components/AboutServicesSection';
import AboutFeaturesSection from '../components/AboutFeaturesSection';
import AboutTeam from '../components/AboutTeamAndAppointmentSection';

const About = () => {
  return (
    <div>
        <AboutSection />
        <AboutServicesSection />
        <AboutFeaturesSection />
        <AboutTeam />
     <div><Footer /></div></div>
  );
  
};

export default About;
